import { render, staticRenderFns } from "./screen_librerias.vue?vue&type=template&id=4c8f5c5f"
import script from "./screen_librerias.vue?vue&type=script&lang=js"
export * from "./screen_librerias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports